import * as React from 'react';
import * as ReactDOM from 'react-dom';

type Props = {
  title: string;
};

export class PageTitle extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.titleEl = document.getElementsByTagName('title')[0];
  }

  private readonly titleEl: HTMLTitleElement;

  render() {
    const { title } = this.props;
    return this.titleEl
      ? ReactDOM.createPortal(` - ${title}`, this.titleEl)
      : null;
  }
}
